var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Groups',{ref:"groupsChat",attrs:{"groups":_vm.groupOpts},on:{"loadMoreUser":_vm.loadMoreUser,"searchUser":_vm.searchUser,"editGroup":_vm.editGroup,"deleteGroup":_vm.deleteGroup}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }